<h3 sidenav-title>{{ 'Mail ' + (data.violations.length | i18nPlural: violationsMappingTerm) + ' via USPS' }}</h3>

<sidenav-content>
    <form [formGroup]="formGroup">
        <p *ngIf="!hasMailingAddress" [innerHTML]="'Choose from the mailing options below. Pricing shown is per letter.'"></p>

        <ng-container *ngIf="hasMailingAddress">
            <div class="grid-layout grid-2">
                <section class="grid-item">
                    <label>{{ 'Unit address:' }}</label>
                    <p [innerHTML]="violations[0].unit?.address | addressLine: false"></p>
                </section>
                <section class="grid-item">
                    <label>{{ (violations[0].unit.owners.length | i18nPlural: ownerAddressesMappingTerm) + ':' }}</label>
                    <ng-container *ngFor="let owner of violations[0].unit.owners">
                        <p *ngIf="owner.membership?.profile?.address1">
                            <span *ngIf="owner.name" [innerHTML]="owner.name + '<br>'"></span>
                            <span [innerHTML]="owner.membership.profile | addressLine: false"></span>
                        </p>
                    </ng-container>
                </section>
            </div>
            <mat-divider></mat-divider>
        </ng-container>

        <div class="form-group mail-options">
            <label id="mailClassControl">{{ 'Shipping' }}</label>
            <mat-radio-group color="primary"
                             formControlName="mailClass"
                             [attr.aria-labelledby]="'mailClassControl'">
                <mat-radio-button [value]="'standard'" disableRipple>
                    <span>{{ 'Standard (1 page / base cost)' }}</span>
                    <span class="meta-text">{{ standardMailingPrice | currency }}</span>
                    <span class="description-text">{{ 'Delivers in 2-3 weeks' }}</span>
                </mat-radio-button>
                <mat-radio-button [value]="'first class'" disableRipple>
                    <span>{{ 'First class (1 page / base cost)' }}</span>
                    <span class="meta-text">{{ firstClassMailingPrice | currency }}</span>
                    <span class="description-text">{{ 'Delivers in 5-8 business days' }}</span>
                </mat-radio-button>
            </mat-radio-group>
        </div>

        <div class="form-group mail-options">
            <label id="trackingControl" *infoTooltip="'Select first class shipping to send as either registered or certified mail.'">{{ 'Tracking' }}</label>
            <mat-radio-group color="primary"
                             formControlName="tracking"
                             [attr.aria-labelledby]="'trackingControl'">
                <mat-radio-button [value]="''" disableRipple>
                    <span>{{ 'None' }}</span>
                    <span class="meta-text">{{ 'No additional cost' }}</span>
                </mat-radio-button>
                <mat-radio-button [value]="'certified'" disableRipple>
                    <span>{{ 'Certified mail' }}</span>
                    <span class="meta-text">{{ '+ ' + (certifiedMailPrice | currency) + ' / letter' }}</span>
                </mat-radio-button>
                <mat-radio-button [value]="'registered'" disableRipple>
                    <span>{{ 'Registered mail' }}</span>
                    <span class="meta-text">{{ '+ ' + (registeredMailPrice | currency) + ' / letter' }}</span>
                </mat-radio-button>
            </mat-radio-group>
        </div>

        <div class="form-group mail-options">
            <label id="colorControl">{{ 'Printing' }}</label>
            <section class="with-border">
                <mat-radio-group color="primary"
                                 formControlName="color"
                                 [attr.aria-labelledby]="'colorControl'">
                    <mat-radio-button [value]="'bw'" disableRipple>
                        <span>{{ 'Black & white' }}</span>
                        <span class="meta-text">{{ 'No additional cost' }}</span>
                    </mat-radio-button>
                    <mat-radio-button [value]="'color'" disableRipple>
                        <span>{{ 'Color' }}</span>
                        <span class="meta-text">{{ '+ ' + (addColorPrice | currency) + ' / page' }}</span>
                    </mat-radio-button>
                </mat-radio-group>

                <mat-slide-toggle formControlName="isDoubleSided" color="primary" disableRipple>
                    <span>{{ 'Two-sided printing' }}</span>
                    <span class="meta-text">{{ 'Saves paper' }}</span>
                </mat-slide-toggle>
            </section>
        </div>

        <div class="form-group mail-options">
            <label id="includeUploadedPdfForEachUnitControl">{{ 'Attached PDF' }}</label>
            <mat-radio-group color="primary"
                             formControlName="includeUploadedPdfForEachUnit"
                             [attr.aria-labelledby]="'includeUploadedPdfForEachUnitControl'">
                <mat-radio-button [value]="false" disableRipple>
                    <span>{{ 'Attach single copy' }}</span>
                    <span class="meta-text">{{ 'No additional cost' }}</span>
                </mat-radio-button>
                <mat-radio-button [value]="true" disableRipple>
                    <span>{{ 'Attach a copy for each unit' }}</span>
                    <span class="meta-text">{{ '+ ' + (attachCopyEachUnitPrice | currency) + ' / page' }}</span>
                </mat-radio-button>
            </mat-radio-group>
        </div>

        <div class="form-group mail-options">
            <label id="sendToControl">{{ 'Send to' }}</label>
            <mat-radio-group color="primary"
                             formControlName="sendTo"
                             [attr.aria-labelledby]="'sendToControl'">
                <mat-radio-button [value]="'unit'" disableRipple>
                    <span>{{ 'Unit address' }}</span>
                    <span class="description-text">{{ 'Send to each unit\'s street address.' }}</span>
                </mat-radio-button>
                <mat-radio-button [value]="'mailing'" disableRipple>
                    <span>{{ violations[0].unit.owners.length | i18nPlural: ownerAddressesMappingTerm }}</span>
                    <span class="description-text">{{ 'Send to each owner\'s mailing address.\n' +
                    'If an owner does not have a separate mailing address, the unit\'s mailing address will be used. Duplicate addresses will be removed.' }}</span>
                </mat-radio-button>
            </mat-radio-group>
        </div>
    </form>
</sidenav-content>

<sidenav-actions>
    <button mat-flat-button disableRipple color="primary" [disabled]="isSendingMail" (click)="mailViolation()">
        {{ 'Mail via USPS' | mobileButton }}
    </button>
    <button-spacer></button-spacer>
    <button mat-flat-button disableRipple color="accent" sidenav-close [disabled]="isSendingMail">{{ 'Cancel' }}</button>
</sidenav-actions>
